import api from '@/services/apiService';

// Booking List Item
export interface BookingListItem {
  invoice_number: string;
  arena_name: string;
  arena_image: string;
  booking_date: string;
  start_time: string;
  end_time: string;
  payment_status: string;
  booking_status: string;
  total_price: number;
  field_count: number;
  field_name?: string;
  sport_name?: string;
}

// Pagination Info
export interface PaginationInfo {
  current_page: number;
  per_page: number;
  total: number;
  total_pages: number;
}

// Booking List Response
export interface BookingListData {
  bookings: BookingListItem[];
  pagination: PaginationInfo;
}

export interface BookingListResponse {
  success: boolean;
  message: string;
  data: BookingListData;
}

// Booking Detail Types
export interface BookerInfo {
  name: string;
  email: string;
  phone?: string;
}

export interface ArenaInfo {
  name: string;
  address: string;
  phone: string;
  email: string;
  whatsapp: string;
  maps_link: string;
  image: string;
}

export interface FieldBookingDetail {
  field_name: string;
  booking_date: string;
  start_time: string;
  end_time: string;
  duration: number;
  price: number;
}

export interface PaymentInfo {
  payment_method: string;
  payment_status: string;
  total_amount: number;
  paid_at: string | null;
}

export interface BookingDetailData {
  invoice_number: string;
  booker_info: BookerInfo;
  arena_info: ArenaInfo;
  field_bookings: FieldBookingDetail[];
  payment_info: PaymentInfo;
}

export interface BookingDetailResponse {
  success: boolean;
  message: string;
  data: BookingDetailData;
}

// Get client bookings with pagination and filter
const getClientBookings = async (
  page: number = 1,
  limit: number = 10,
  status: string = ''
): Promise<BookingListResponse> => {
  const params = new URLSearchParams({
    page: page.toString(),
    limit: limit.toString(),
  });

  if (status) {
    params.append('status', status);
  }

  const response = await api.get(`/client/bookings?${params.toString()}`);
  return response.data;
};

// Get booking detail by invoice number
const getBookingDetail = async (invoiceNumber: string): Promise<BookingDetailResponse> => {
  const response = await api.get(`/client/bookings/${invoiceNumber}`);
  return response.data;
};

export const clientBookingService = {
  getClientBookings,
  getBookingDetail,
};
